import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const usePremiumStoreResetPassword = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('resetPremiumStorePassword', {
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: ['premiumStores'] });
      toast.success(data.message);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
